export default "__VITE_ASSET__5Nl95fAe__"